module.exports = __webpack_public_path__ + "img/hgznq.3928ee06.jpg";